import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import AppDataGrid from "../../common/AppDataGrid";

const adminColumns = [
  { field: "Term_Id_Cd", headerName: "Term Id", minWidth: 90 },
  { field: "Course_Section_Nm", headerName: "Course Section", minWidth: 150 },
  { field: "course_section_create_date", headerName: "Created", minWidth: 120 },
  { field: "Days", headerName: "Days", minWidth: 80 },
  { field: "Start_Time", headerName: "Start Time", minWidth: 100 },
  { field: "End_Time", headerName: "End Time", minWidth: 100 },
  { field: "Course_Section_Status_Cd", headerName: "Status", minWidth: 90 },
  { field: "Capacity_Ct", headerName: "Capacity", minWidth: 90 },
  { field: "Used", headerName: "Used", minWidth: 70 },
  {
    field: "Minimum_Credit_Hour_Ct",
    headerName: "Min Credit Hrs",
    minWidth: 115,
  },
  { field: "Bldg", headerName: "Bldg", minWidth: 80 },
  { field: "room", headerName: "Room", minWidth: 80 },
  { field: "Location", headerName: "Location", minWidth: 100 },
  { field: "Instructor", headerName: "Instructor", minWidth: 150 },
  { field: "Email", headerName: "Email", minWidth: 190 },
  { field: "Tartan_Id", headerName: "Tartan Id", minWidth: 100 },
  { field: "Position_Type_Cd", headerName: "Position Type", minWidth: 120 },
  { field: "position", headerName: "Position", minWidth: 120 },
  { field: "Printed_Comments_Ds", headerName: "Comments", minWidth: 180 },
  { field: "Reg_Restriction_Cd", headerName: "Reg Restriction", minWidth: 120 },
  { field: "Start_Dt", headerName: "Start", minWidth: 110 },
  { field: "End_Dt", headerName: "End", minWidth: 110 },
  { field: "Drop_Grade_Req_Dt", headerName: "Drop Grade Req", minWidth: 130 },
  { field: "Withdrawal_Dt", headerName: "Withdrawal", minWidth: 120 },
  { field: "Highlight_In", headerName: "Highlight In", minWidth: 100 },
  { field: "Department_Id_Cd", headerName: "Department", minWidth: 120 },
  { field: "Division_Id_Cd", headerName: "Division", minWidth: 110 },
];

const schoolColumns = [
  { field: "Capacity_Ct", headerName: "Capacity", minWidth: 90 },
  { field: "Term_Id_Cd", headerName: "Term Id", minWidth: 90 },
  { field: "Course_Section_Nm", headerName: "Course Section", minWidth: 180 },
  { field: "Days", headerName: "Days", minWidth: 80 },
  { field: "Start_Time", headerName: "Start Time", minWidth: 110 },
  { field: "End_Time", headerName: "End Time", minWidth: 110 },
  { field: "Instructor", headerName: "Instructor", minWidth: 160 },
  { field: "Start_Dt", headerName: "Start", minWidth: 110 },
  { field: "End_Dt", headerName: "End", minWidth: 110 },
];

/**
 * XcsiTable — reusable XCSI data grid.
 *
 * Props:
 *   data       {Array}   — rows from useFetchXCSI (already have _rowId stamped)
 *   loading    {boolean} — loading state
 *   bldg       {string}  — if provided, pre-filters rows where Bldg === bldg
 *   title      {string}  — optional heading shown above the table
 *   schoolView {boolean} — if true, shows the reduced school-facing column set
 */
const XcsiTable = ({
  data = [],
  loading = false,
  bldg = null,
  title = null,
  schoolView = false,
}) => {
  const columns = schoolView ? schoolColumns : adminColumns;

  const rows = bldg
    ? (data || []).filter(
        (row) => String(row.Bldg || "").trim() === String(bldg).trim(),
      )
    : data || [];

  return (
    <Card sx={{ width: "100%", mt: 1 }}>
      <CardContent>
        {title && (
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            {title}
          </Typography>
        )}
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <AppDataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row._rowId}
            loading={loading}
            autoHeight
            pagination
            pageSize={25}
            pageSizeOptions={[25, 50, 100]}
            disableColumnMenu={false}
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 600 },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default XcsiTable;
